export const ADD_RECORD = 'ADD_RECORD';

export function addRecord(recordData) {
    return {
        type: ADD_RECORD,
        payload: recordData
    };
}
